export default "__VITE_ASSET__BGIssiOP__"